<template>
    <CollapsibleCardBase>
        <template #title>
            <div class="mt-1 font-bold text-sm">
                {{ missionDetail.mission_profile.number_of_patients }}
                {{ $tc('text.patient', missionDetail.mission_profile.number_of_patients) }}
            </div>
        </template>
        <template #content>
            <div class="text-sm leading-tight text-gray-600">
                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $tc('text.patient', 1) }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <MissionDetailGender :gender="patient.gender"></MissionDetailGender>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.age') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <div class="ml-1">{{ patient.age }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.weight') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <div class="ml-1">{{ patient.weight }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.mobility') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <div class="ml-1">{{ mobility(patient) }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.night_work') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, index) in missionDetail.patients" :key="index">
                        <div class="ml-1">{{ night_work(patient) }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('text.additional') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, patientIndex) in missionDetail.patients" :key="patientIndex">
                        <div class="ml-1 mb-1" v-for="(disease, diseaseIndex) in diseasesList(patient)" :key="diseaseIndex">{{ disease }}</div>
                    </div>
                </div>

                <div class="w-full flex p-1" v-if="showFurtherDiseases">
                    <div class="w-1/3 text-right pr-2">
                        <div>{{ $t('component.missionProfile.patients.further_diseases') }}</div>
                    </div>
                    <div class="w-1/3 text-black" v-for="(patient, patientIndex) in missionDetail.patients" :key="patientIndex">
                        <div class="ml-1 mb-1">{{ patient.further_diseases }}</div>
                    </div>
                </div>
            </div>
        </template>
    </CollapsibleCardBase>
</template>

<script>
    import CollapsibleCardBase from "@/components/shared/CollapsibleCardBase";
    import MissionDetailGender from "@/components/missions/MissionDetailGender";

    export default {
        name: "MissionProfilePatients",
        props: ['missionDetail'],
        components: {CollapsibleCardBase, MissionDetailGender },
        computed: {
            showFurtherDiseases() {
                let show = false;

                this.missionDetail.patients.forEach(function (patient) {
                    if (patient.further_diseases !== '') {
                        show = true;
                    }
                })

                return show;
            }
        },
        methods: {
            night_work(patient) {
                let night_work = '';

                if (patient === undefined)
                    return night_work;

                switch (patient.night_work) {
                    case 0:
                        return this.$t('text.night_work_0');
                    case 1:
                        return this.$t('text.night_work_1');
                    case 2:
                        return this.$t('text.night_work_2');
                    default:
                        return this.$t('text.unknown');
                }
            },

            mobility(patient) {
                let mobility = '';

                if (patient === undefined)
                    return mobility;

                switch (patient.mobility) {
                    case 1:
                        return this.$t('text.mobility_1');
                    case 2:
                        return this.$t('text.mobility_2');
                    case 3:
                        return this.$t('text.mobility_3');
                    case 4:
                        return this.$t('text.mobility_4');
                    case 5:
                        return this.$t('text.mobility_5');
                    default:
                        return this.$t('text.unknown');
                }
            },

            diseasesList(patient) {
                let diseases = [];
                let self = this;

                if (patient === undefined)
                    return diseases;

                patient.diseases.forEach(function (c) {
                    switch (c) {
                        case '0':
                            diseases.push(self.$t('text.disease_0'));
                            break;
                        case '1':
                            diseases.push(self.$t('text.disease_1'));
                            break;
                        case '2':
                            diseases.push(self.$t('text.disease_2'));
                            break;
                        case '3':
                            diseases.push(self.$t('text.disease_3'));
                            break;
                        case '4':
                            diseases.push(self.$t('text.disease_4'));
                            break;
                        case '5':
                            diseases.push(self.$t('text.disease_5'));
                            break;
                        case '6':
                            diseases.push(self.$t('text.disease_6'));
                            break;
                        case '7':
                            diseases.push(self.$t('text.disease_7'));
                            break;
                        case '8':
                            diseases.push(self.$t('text.disease_8'));
                            break;
                        case '9':
                            diseases.push(self.$t('text.disease_9'));
                            break;
                        case '10':
                            diseases.push(self.$t('text.disease_10'));
                            break;
                        case '11':
                            diseases.push(self.$t('text.disease_11'));
                            break;
                        case '12':
                            diseases.push(self.$t('text.disease_12'));
                            break;
                        case '13':
                            diseases.push(self.$t('text.disease_13'));
                            break;
                        case '14':
                            diseases.push(self.$t('text.disease_14'));
                            break;
                        case '15':
                            diseases.push(self.$t('text.disease_15'));
                            break;
                        case '16':
                            diseases.push(self.$t('text.disease_16'));
                            break;
                    }
                });

                return diseases;
            }
        }
    }
</script>

<style scoped>

</style>